/** Prefill helpers for Crear colección query params and filter chips. */

/** Mirrors backend `normalizeHashtagList`: split on commas/spaces, strip `#`, lowercase. */
export function normalizeCollectionHashtags(raw: string[]): string[] {
  const out = new Set<string>();
  for (const item of raw) {
    for (const piece of item.split(/[\s,]+/)) {
      const tag = piece
        .replace(/^#+/, "")
        .toLowerCase()
        .replace(/[^\p{L}\p{N}_]/gu, "");
      if (tag) out.add(tag);
    }
  }
  return Array.from(out);
}

/** Trim, lowercase, split comma-separated chips; keep phrases with spaces. */
export function normalizeCollectionKeywords(raw: string[]): string[] {
  const out = new Set<string>();
  for (const item of raw) {
    for (const piece of item.split(",")) {
      const kw = piece.trim().toLowerCase();
      if (kw.length >= 2) out.add(kw);
    }
  }
  return Array.from(out);
}

export function parsePrefillHashtags(raw: string | null): string[] {
  if (!raw?.trim()) return [];
  return normalizeCollectionHashtags([raw]);
}

export function parsePrefillKeywords(raw: string | null): string[] {
  if (!raw?.trim()) return [];
  return normalizeCollectionKeywords([raw]);
}

export function collectProgramTextFilters(
  programs: Array<{ hashtags?: unknown; keywords?: unknown }>,
): { hashtags: string[]; keywords: string[] } {
  const hashtags: string[] = [];
  const keywords: string[] = [];
  for (const program of programs) {
    if (Array.isArray(program.hashtags)) {
      for (const tag of program.hashtags) {
        if (typeof tag === "string") hashtags.push(tag);
      }
    }
    if (Array.isArray(program.keywords)) {
      for (const keyword of program.keywords) {
        if (typeof keyword === "string") keywords.push(keyword);
      }
    }
  }
  return {
    hashtags: normalizeCollectionHashtags(hashtags),
    keywords: normalizeCollectionKeywords(keywords),
  };
}

export function appendProgramCollectionFilters(
  params: URLSearchParams,
  input: { hashtags?: string[]; keywords?: string[] },
): URLSearchParams {
  const hashtags = normalizeCollectionHashtags(input.hashtags ?? []);
  const keywords = normalizeCollectionKeywords(input.keywords ?? []);
  if (hashtags.length) params.set("hashtags", hashtags.join(","));
  if (keywords.length) params.set("keywords", keywords.join(","));
  return params;
}

